module.exports = __webpack_public_path__ + "img/be.58ae33e6.svg";